/**
 * Trade-in estimate rules.
 * Keep in sync with calculateNewEstimate.js / checkNonContender.js in bilbolaget-evaluate-car.
 */

// A car matching any of these can not be valued online.
// Each entry only checks the keys it sets; maxMileage is in mil (exclusive).
const nonContenders = [
    { minHp: 550 },
    { minPrice: 600000 },
    { maxMileage: 1000 },
]

// Rules with fuelTypes are checked before the rule without
const rules = [
    {
        fuelTypes: ['El'],
        ranges: [
            { from: 0, to: 399999, deduction: .12, min: 25000, max: 36000 },
            { from: 400000, to: Infinity, deduction: .09, min: 0, max: Infinity },
        ]
    },
    {
        fuelTypes: ['Laddhybrid','Hybrid','Elhybrid'],
        ranges: [
            { from: 0, to: 399999, deduction: .15, min: 32000, max: 50000 },
            { from: 400000, to: Infinity, deduction: .13, min: 0, max: Infinity },
        ]
    },
    {
        ranges: [
            { from: 0, to: 399999, deduction: .16, min: 35000, max: 55000 },
            { from: 400000, to: Infinity, deduction: .14, min: 0, max: Infinity },
        ]
    },
]

const conditionDeduction = {
    'Mycket bra skick': 8000,
    'Bra skick': 12000,
    'Helt ok skick': 16000,
    'Dåligt skick': 28000,
}

/**
 * @param {object} car { price_prediction, enginePower, mileage (mil), fuelType, condition }
 * @returns {number} estimated price, 0 if the car can not be valued
 */
export function estimateTradeIn({ price_prediction, enginePower, mileage, fuelType, condition }) {
    const isNonContender = nonContenders.some(({ minHp, minPrice, maxMileage }) =>
        (minHp === undefined || enginePower >= minHp) &&
        (minPrice === undefined || price_prediction >= minPrice) &&
        (maxMileage === undefined || mileage < maxMileage)
    )
    if (isNonContender) return 0

    const rule = rules.find(r => r.fuelTypes?.includes(fuelType)) || rules.find(r => !r.fuelTypes)
    const range = rule.ranges.find(r => r.from <= price_prediction && price_prediction <= r.to)
    const deduction = range
        ? Math.max(Math.min(price_prediction * range.deduction, range.max), range.min)
        : 0

    const price = price_prediction - (deduction + (conditionDeduction[condition] || 0))
    return price > 0 ? price : 0
}
